import React from 'react';
import { Card } from '../components/ui';
import { BLUE_PRIMARY, BLUE_PRIMARY_DARK } from '../theme';

export default function NutritionAssessments({ stats }) {
  const backend = stats;
  if (!backend) return null;

  const total = typeof backend.total === 'number' ? backend.total : 0;
  if (!total) return null;

  const healthy = backend.healthy_count || 0;
  const notHealthy = backend.not_healthy_count || 0;

  const pct = (n, d) => (d ? Math.round((n / d) * 1000) / 10 : 0);

  const healthyPct = (typeof backend.healthy_pct === 'number') ? backend.healthy_pct : pct(healthy, total);
  const notHealthyPct = (typeof backend.not_healthy_pct === 'number') ? backend.not_healthy_pct : pct(notHealthy, total);

  return (
    <Card title="Beslenme Durumları">
      <div style={{ display: 'grid', gap: 10 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div style={{ background: '#fff', border: '1px solid #eef2f7', borderRadius: 12, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
              <div style={{ fontSize: 12, color: '#16a34a', fontWeight: 700 }}>Sağlıklı</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>{healthyPct}%</div>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{healthy}</div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #eef2f7', borderRadius: 12, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
              <div style={{ fontSize: 12, color: BLUE_PRIMARY_DARK, fontWeight: 700 }}>Sağlıksız</div>
              <div style={{ fontSize: 12, color: '#64748b' }}>{notHealthyPct}%</div>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{notHealthy}</div>
          </div>
        </div>

        <div style={{ height: 10, borderRadius: 999, overflow: 'hidden', background: '#eef2f7', display: 'flex' }}>
          <div style={{ width: `${healthyPct}%`, background: '#22c55e' }} />
          <div style={{ width: `${notHealthyPct}%`, background: BLUE_PRIMARY }} />
        </div>

        <div style={{ fontSize: 12, color: '#64748b' }}>
          Toplam kayıt: <span style={{ fontWeight: 700, color: '#0f172a' }}>{total}</span>
        </div>
      </div>
    </Card>
  );
}
